import { ApolloClient, gql, HttpLink, InMemoryCache } from "@apollo/client/core";

export class GqlClientV2 {
    private fetch:  ((input: RequestInfo, init?: (RequestInit | undefined)) => Promise<Response>) | undefined;

    /**
     * Creates a new GqlClientV2 instance
     * @param fetch Custom fetch function for HTTP requests
     */
    constructor(
       fetch: ((input: RequestInfo, init?: (RequestInit | undefined)) => Promise<Response>) | undefined
    ) {
       this.fetch = fetch;
    }

    getClient = () => {
        return new ApolloClient({
            cache: new InMemoryCache({}),
            link: new HttpLink({
                uri: '/graphV2',
                fetch: this.fetch
            }),
            queryDeduplication: false
        });
    }
}